import React from 'react';
import '../../../../../../styles/table-accesory.css';
import { ACCESORIES, RIM_OR_WELLS } from '../../../../../../constants/app/files';

const TableAccesory = ({ accessories = []}) => {
    return (
        (accessories && accessories.length > 0)?
            <table>
                <tbody>
                    {
                        accessories.map((accessory, index) => 
                            <tr style={{backgroundColor: 'transparent'}} key={index}>
                                <td className="text-md" style={{padding: 0}}>{accessory.quantity}</td>
                                <td className="text-md" style={{padding: 0}}>{ACCESORIES[accessory.accessoryCode] || RIM_OR_WELLS[accessory.accessoryCode]}</td>
                                <td className="text-md" style={{padding: 0}}>{accessory.accessoryBrandModel}</td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
            :
            <div className="text-md">No tiene accesorios adicionales</div>
    );
}

export default TableAccesory;



// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspection/components/resolve/table-accessory.js